import Vue from 'vue';
import unitOfMeasureTransformer from './../../transformers/unitOfMeasure';

const success = (resolve, response) => {
  resolve(unitOfMeasureTransformer.fetch(response.data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(unitOfMeasureTransformer.fetch(errors));
};

export default unitOfMeasure => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/unit_of_measures', unitOfMeasure)
      .then((response) => {
        success(resolve, response);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/unitOfMeasure/store.js